import styled from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.div`
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  scrollbar-color: #E3E3E3 transparent;


  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
`;

export default Wrapper(template);